import { ITerritorialUnit } from 'APIPackage/CatalogsModule/interfaces/ITerritorialUnit';

import { ITerritorialUnitSelectOption } from '../interfaces/ITerritorialUnitSelectOption';

export const createTerritoryUnitsSelectOption = (territorialUnit: ITerritorialUnit): ITerritorialUnitSelectOption => ({
  ...territorialUnit,
  label: territorialUnit.value,
  value: territorialUnit.value,
});
